export default __webpack_public_path__ + "static/media/menu_settings_selected.d59862ff.svg";